var _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgClippingReviewsWave(props, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 828 518",
    ref: svgRef
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "objectBoundingBox",
    id: "clipping-reviews-wave_svg__reviews-wave-mask"
  }, /*#__PURE__*/React.createElement("path", {
    transform: "matrix(.00242 0 0 .0012 0 -.17)",
    d: "M414 0H0v953.972S23.7 938.5 104.718 938.5c34.731 1.451 64.968 9.224 94.679 16.86 31.696 8.147 62.792 16.14 98.103 16.14 62.5 0 116.5-17.528 116.5-17.528V0z",
    fill: "#fff"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgClippingReviewsWave);
export default "data:image/svg+xml;base64,PHN2ZyBmaWxsPSJub25lIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCA4MjggNTE4Ij4KICA8ZGVmcz4KICAgIDxjbGlwUGF0aCBjbGlwUGF0aFVuaXRzPSJvYmplY3RCb3VuZGluZ0JveCIgaWQ9InJldmlld3Mtd2F2ZS1tYXNrIj4KICAgICAgPHBhdGggdHJhbnNmb3JtPSJzY2FsZSgwLjAwMjQxNTQ1LCAwLjAwMTIpIHRyYW5zbGF0ZSgwLCAtMTQyKSIgZD0iTTQxNCAwSDBWOTUzLjk3MkMwIDk1My45NzIgMjMuNzAwNyA5MzguNSAxMDQuNzE4IDkzOC41QzEzOS40NDkgOTM5Ljk1MSAxNjkuNjg2IDk0Ny43MjQgMTk5LjM5NyA5NTUuMzZDMjMxLjA5MyA5NjMuNTA3IDI2Mi4xODkgOTcxLjUgMjk3LjUgOTcxLjVDMzYwIDk3MS41IDQxNCA5NTMuOTcyIDQxNCA5NTMuOTcyVjBaIiBmaWxsPSJ3aGl0ZSIvPgogICAgPC9jbGlwUGF0aD4KICA8L2RlZnM+Cjwvc3ZnPg==";
export { ForwardRef as ReactComponent };